import { Navigate, useLocation } from 'react-router-dom';
import { isDemoMode } from '../../demo/demoState';

/**
 * RootRedirect handles the root route (/).
 * - Demo mode: redirect to /home preserving full search string
 * - Authenticated: handled by App.tsx navigation guard
 * - Otherwise: redirect to /auth/login
 */
export function RootRedirect() {
  const location = useLocation();

  if (isDemoMode()) {
    return <Navigate to={`/home${location.search}`} replace />;
  }

  return <Navigate to="/auth/login" replace />;
}
